<script setup>
import { computed } from 'vue';

const props = defineProps({
  cards: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  columns: {
    type: Number,
    default: 4,
  },
  skeletonCount: {
    type: Number,
    default: null,
  },
});

const gridCols = computed(() => {
  switch (props.columns) {
    case 2:
      return 'sm:grid-cols-2';
    case 3:
      return 'sm:grid-cols-2 lg:grid-cols-3';
    default:
      return 'sm:grid-cols-2 lg:grid-cols-4';
  }
});

const skeletons = computed(
  () => props.skeletonCount ?? props.cards.length ?? 4
);
</script>

<template>
  <div class="grid grid-cols-1 gap-3" :class="gridCols">
    <template v-if="loading">
      <div
        v-for="n in skeletons"
        :key="`skeleton-${n}`"
        class="flex flex-col gap-2 border rounded-lg border-n-slate-4 bg-n-solid-1 p-4 animate-pulse"
      >
        <div class="h-3 w-24 rounded bg-n-alpha-2" />
        <div class="h-7 w-20 rounded bg-n-alpha-2 mt-0.5" />
        <div class="h-3 w-32 rounded bg-n-alpha-2 mt-1" />
      </div>
    </template>
    <template v-else>
      <div
        v-for="card in cards"
        :key="card.key"
        class="flex flex-col gap-1.5 border rounded-lg border-n-slate-4 bg-n-solid-1 p-4"
      >
        <span
          class="text-xs font-semibold uppercase tracking-wide text-n-slate-11"
        >
          {{ card.label }}
        </span>
        <span class="text-2xl font-semibold text-n-slate-12 tabular-nums">
          {{ card.value }}
        </span>
        <span v-if="card.description" class="text-xs text-n-slate-10">
          {{ card.description }}
        </span>
      </div>
    </template>
  </div>
</template>
